export default __webpack_public_path__ + "static/media/logo.d33f2e86.png";